import React from 'react'
import PropTypes from 'prop-types'
import I18n from 'translations/i18n'
import { Typography } from '@jisr-hr/ds'

import { ReactComponent as ArrowIcon } from './icons/diagram-arrow.svg'

import Frame from '../../ds/Frame'
import Styles from './style.module.css'

const InfoChange = ({ items }) => {
  return (
    <Frame title={I18n.t('information_changes')}>
      <table className={Styles.infoChangeTable}>
        <tbody>
          {items.map(({ label, newValue, oldValue }, i) => {
            return (
              <tr
                className={Styles.infoChangeRow}
                key={i}
              >
                <td className={Styles.infoChangeCell}>
                  <Typography
                    textColor="color/fg/lighter"
                    text={label}
                    variant="body-new/regular"
                  />
                </td>
                <td className={Styles.infoChangeCell}>
                  <Typography
                    text={oldValue || '--'}
                    variant="body-new/regular"
                  />
                </td>
                <td className={Styles.infoChangeCell}>
                  <ArrowIcon className={Styles.rotateY180} />
                </td>
                <td className={Styles.infoChangeCell}>
                  <Typography
                    text={newValue || '--'}
                    variant="body-new/semibold"
                  />
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </Frame>
  )
}

InfoChange.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape()),
}

export default InfoChange
